export const ServiziEccellenza = [
  '730',
  'ANT',
  'UIC',
  'CEB',
  'CIA',
  'LOC',
  'FDC',
  'FEA',
  'ISE',
  'LEG',
  'GDP',
  'RED',
  'SCI',
  'SIN',
  'SUC',
  'BDC',
  'VIP',
  'ANF',
  'SUP',
  'CUN',
  'PCA',
  'ICI',
  'PIC',
  'RIC',
  'RDV',
  'DIC',
  'UNI',
];

export default function isServizioInServiziPianoEccellenza(servizio) {
  return ServiziEccellenza.includes(servizio);
}
